import { EncryptStorage } from 'encrypt-storage';
export default new EncryptStorage('window.location is ' + window.location.origin, null);